import getUrl from "Libs/getUrl";

import type { AgentRun } from "Reducers/agentRuns";

/**
 * The run's log under its task. The Report tab is the default for an agent
 * activity (`LogModal`), so one URL serves a run in flight and a finished one.
 */
export const getAgentRunUrl = (run: AgentRun) =>
  getUrl({
    key: "organization.project.environment.tasks.taskName.activity.log",
    props: {
      organizationId: run.organizationId,
      projectId: run.projectId,
      environmentId: run.environmentId,
      taskName: run.taskName,
      activityId: run.activityId
    }
  });
